module.exports = __webpack_public_path__ + "media/images/header-bg_photo-9920aa6ba411abc513de1bf9a66c7512.jpg";